import { cx } from '@/ui/cva';
import { Link, LinkProps } from '@/ui/Link';

export type FancyLinkProps = LinkProps & {
    isActive?: boolean;
};

export function FancyLink({ className, isActive, ...props }: FancyLinkProps) {
    return (
        <Link
            {...props}
            className={cx(
                'text-inherit',
                'no-underline',
                'relative',
                'before:absolute',
                'before:bg-gradient-to-r',
                'before:from-[--gradient-start]',
                'before:to-[--gradient-end]',
                'before:rounded-full',
                'before:top-full',
                'before:left-0',
                'before:transition-all',
                'before:h-[3px]',
                'before:w-0',
                'before:opacity-0',
                isActive && 'before:w-[24px] before:opacity-100',
                'hover:before:w-[24px] hover:before:opacity-100',
                className
            )}
        />
    );
}
